import { apiRequest, deviceList, resetDevice } from "../../../../services/adapters/base";

class DataTableRepository {
  fetchRowTable = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      deviceList,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchDelete = async (query, cancelToken) => {
    return await apiRequest(
      "post",
      resetDevice,
      {
        cancelToken: cancelToken,
        body: query,
      },
      true
    );
  };
}

export default DataTableRepository;
